export { SupportComponent } from './support.component';
export { LearnMoreComponent } from './learnmore.component';
export { PrivacyComponent } from './privacy.component';
